import { render, staticRenderFns } from "./VehicleInsuranceItem.vue?vue&type=template&id=465c5a54&scoped=true"
import script from "./VehicleInsuranceItem.vue?vue&type=script&lang=js"
export * from "./VehicleInsuranceItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleInsuranceItem.vue?vue&type=style&index=0&id=465c5a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465c5a54",
  null
  
)

export default component.exports